/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.autoSaveModule', ['restangular', 'bulbApp.errorModule', 'bulbApp.translateModule'])
  .constant('AUTO_SAVE', {
    STATUS: {
      PRISTINE: 'AUTO_SAVE_PRISTINE',
      DIRTY: 'AUTO_SAVE_DIRTY',
      SAVING: 'AUTO_SAVE_SAVING',
      SAVED: 'AUTO_SAVE_SAVED',
      RETRYING: 'AUTO_SAVE_RETRYING',
      ERROR: 'AUTO_SAVE_ERROR',
    },
  });
